import type { ListProps } from '@chakra-ui/react';
import { Button, List, ListItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { menuItems } from '../constants';

interface IMenuProps extends ListProps {
  onItemClick?: () => void;
}

export const Menu: React.FC<IMenuProps> = (props): JSX.Element => {
  const { onItemClick, ...rest } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    id: string,
    url: string
  ): void => {
    event.preventDefault();
    const element = document.querySelector(`#${id}`);
    setTimeout(() => element?.scrollIntoView(), 200);
    if (onItemClick) onItemClick();
    navigate(url);
  };

  return (
    <List as="nav" {...rest}>
      {menuItems.map((item) => (
        <ListItem key={`menuItem-${item.id}`}>
          <Button
            _hover={{ textDecoration: 'underline' }}
            as="a"
            fontSize="large"
            fontWeight="medium"
            lineHeight="normal"
            paddingInlineEnd={0}
            paddingInlineStart={0}
            variant="link"
            onClick={(e): void => handleNavClick(e, item.id, item.href)}
          >
            {t(item.label)}
          </Button>
        </ListItem>
      ))}
    </List>
  );
};
